import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { DataGridPerson } from '@components/DataGrid/DataGridPerson'
import ExampleLocation from '@assets/exampleLocation.png'
import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import {
  ActionIcon,
  Anchor,
  Button,
  Group,
  Menu,
  ThemeIcon,
} from '@mantine/core'
import { randomArrayItem } from '@utils/randomArrayItem'
import { DataGridList } from '@components/DataGrid/DataGridList'
import {
  IconCalendarEvent,
  IconChecklist,
  IconChevronDown,
  IconDots,
} from '@tabler/icons-react'
import { buildLink } from '@utils/buildLink'

export const Partners = () => {
  const navigate = useNavigate()

  const handleNavigate = () =>
    navigate(`../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`, {
      state: {
        history: [
          {
            title: 'Community',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_INVITES}`,
          },
          {
            title: 'Partners',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_PARTNERS}`,
          },
        ],
      },
    })

  const data = Array(30)
    .fill(0)
    .map((_, i) => {
      return {
        id: `partners-${i}`,
        name: (
          <DataGridPerson
            name="Children's Aid Society"
            image={ExampleLocation}
            status="online"
            onClick={handleNavigate}
          />
        ),
        tags: (
          <DataGridList title="Tags" data={['Some', 'Another', 'Another']} />
        ),
        status: (
          <Group gap={0}>
            <ThemeIcon variant="transparent" color="dark.7">
              <IconCalendarEvent size={22} />
            </ThemeIcon>
            <ThemeIcon variant="transparent" color="dark.7">
              <IconChecklist size={22} />
            </ThemeIcon>
          </Group>
        ),
        phone: (
          <Anchor href="tel:+1 (212) 555-1212" size="sm" c="dark.7">
            +1 (212) 555-1212
          </Anchor>
        ),
        email: 'info@childrensaid.com',
        website: (
          <Anchor
            size="sm"
            href={buildLink('childrensaid.com')}
            c="dark.4"
            target="_blank"
          >
            childrensaid.com
          </Anchor>
        ),
        lastUpdated: randomArrayItem(['Today', '6w 3d', '2mo 21d', '1yr 3mo']),
      }
    })

  const columns: DataGridColumns[] = [
    {
      label: 'Name',
      prop: 'name',
      defaultSort: true,
      pinned: true,
    },
    {
      label: 'Tags',
      prop: 'tags',
    },
    {
      label: 'Phone',
      prop: 'phone',
    },
    {
      label: 'Email',
      prop: 'email',
    },
    {
      label: 'Website',
      prop: 'website',
    },
    {
      label: 'Status',
      prop: 'status',
    },
    {
      label: 'Last updated',
      prop: 'lastUpdated',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'Community Partners',
      href: '#',
      default: true,
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Edit custom fields',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Add tags',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Remove tag',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
    {
      label: 'Delete record',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Edit',
      onClick: (items: any) => console.log('Selected Actions: Edit'),
    },
    {
      label: 'Tags',
      onClick: (items: any) => console.log('Selected Actions: Tags'),
      component: (
        <div>
          <Menu position="bottom-start">
            <Menu.Target>
              <Button
                variant="default"
                rightSection={<IconChevronDown size={18} />}
              >
                Tags
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Add tags</Menu.Item>
              <Menu.Item color="red">Remove tags</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
    {
      label: 'Select all linked records',
      onClick: (items: any) =>
        console.log('Selected Actions: Select all linked records'),
    },
    {
      label: 'Options',
      onClick: (items: any) => {},
      component: (
        <div>
          <Menu>
            <Menu.Target>
              <ActionIcon variant="default" radius="xl" aria-label="Options">
                <IconDots
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item>Link records</Menu.Item>
              <Menu.Item color="red">Delete records</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      ),
    },
  ]

  return (
    <>
      <DataGrid
        data={data}
        columns={columns}
        sections={sections}
        actions={actions}
        results={data.length}
        selectedActions={selectedActions}
        page={1}
      />
    </>
  )
}
